import { useEffect, useState } from "react";
import { toast } from "sonner";
import { CalendarClock, X } from "lucide-react";
import { Card, Btn, inputCls } from "./ui";

const pad = (n) => String(n).padStart(2, "0");
const toLocalInput = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
const defaultTime = () => {
  const d = new Date(Date.now() + 24 * 3600 * 1000);
  d.setHours(10, 0, 0, 0);
  return toLocalInput(d);
};

export const SchedulePanel = ({ status, scheduledAt, disabled, onSchedule, onCancel }) => {
  const [when, setWhen] = useState(scheduledAt ? toLocalInput(new Date(scheduledAt)) : defaultTime());
  useEffect(() => { if (scheduledAt) setWhen(toLocalInput(new Date(scheduledAt))); }, [scheduledAt]);
  const scheduled = status === "scheduled";

  const submit = () => {
    const d = new Date(when);
    if (Number.isNaN(d.getTime())) return toast.error("Pick a date and time");
    if (d <= new Date()) return toast.error("Pick a time in the future");
    onSchedule(d.toISOString());
  };

  return (
    <Card title="Schedule publishing" testid="schedule-panel">
      {scheduled && (
        <p className="mb-3 flex items-center gap-2 rounded-lg border border-amber-400/30 bg-amber-400/10 px-3 py-2 text-xs text-amber-300" data-testid="schedule-status">
          <CalendarClock size={14} /> Goes live {new Date(scheduledAt).toLocaleString()}
        </p>
      )}
      <p className="mb-2 text-xs text-zinc-500">Publishes automatically at your local time ({Intl.DateTimeFormat().resolvedOptions().timeZone}).</p>
      <input type="datetime-local" value={when} min={toLocalInput(new Date())} onChange={(e) => setWhen(e.target.value)}
        className={`${inputCls} [color-scheme:dark]`} data-testid="schedule-datetime" />
      <div className="mt-3 flex flex-wrap gap-2">
        <Btn onClick={submit} disabled={disabled} data-testid="schedule-submit"><CalendarClock size={14} /> {scheduled ? "Update schedule" : "Schedule"}</Btn>
        {scheduled && <Btn variant="outline" onClick={onCancel} disabled={disabled} data-testid="schedule-cancel"><X size={14} /> Cancel schedule</Btn>}
      </div>
    </Card>
  );
};
